import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';

// import { fieldName, displayName } from '../../../CommonFunctions/CommonFunctions';
import { getGeoJSON } from '../GeoJSON/MapCommonFunctions';
import { Dispatch } from 'redux';
import {
  changeGeoMapUnMatched,
  changeGeoKey,
} from '../../../../redux/ChartPoperties/ChartPropertiesActions';

import { ffDialogTitle, ffButtonStyle } from '../../../DataConnection/muiStyles';
import { fontSize } from '../../../..';
import { useDispatch } from 'react-redux';
import Properties from '../../../DashBoard/Properties/Properties';
import { getGeoJSONDB} from '../GeoJSON/GeoJSONDatabase';

const GoeMismatch = ({
  propKey,
  open,
  handleClose,
  misMatchList,
  geoJSON,
  changeGeoMapUnMatched,
  chartControls,
  chartProperties,
}: any) => {
  const [unMatchedArray, setUnMatchedArray] = useState<any>([]);
  const [loadingCities, setLoadingCities] = useState(false);

  const [options, setOptions] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [isNull, setIsNull] = useState(false);

  const geoMapKey = chartProperties.properties[propKey].Geo.geoMapKey;

  // const [trimmedNames, setTrimmedNames] = useState<string>("");

  // Determine dimension name (e.g., "city" or "state")
  let dimensionName = chartProperties.properties[propKey].chartAxes[1].fields[0]?.displayname;
  if (chartProperties.properties[propKey].chartType === 'bubbleMap') {
    dimensionName = chartProperties.properties[propKey].chartAxes[2].fields[0]?.displayname;
  }

  const removeBlankValues = (data: any[], dimensionName: string) => {
    return data.filter((item: any) => {
      const raw = item?.[dimensionName];

      if (raw === null || raw === undefined) return false;

      if (Array.isArray(raw)) {
        return raw.some((v) => String(v ?? '').trim() !== '');
      }

      return String(raw).trim() !== '';
    });
  };

  useEffect(() => {
    const hasNullInMismatch = misMatchList?.some((item: any) => {
      return item?.region === null || item?.region === '' || item?.[dimensionName] === null;
    });

    setIsNull(hasNullInMismatch);
  }, [misMatchList,chartProperties.properties[propKey].Geo.unMatchedChartData, options]);


  const getFilteredUnmatched = (data: any[], options: string[], dimensionName: string) => {
    if (!data) return [];

    const nonBlankData = removeBlankValues(data, dimensionName);

    if (!options || options.length === 0) return nonBlankData;

    return nonBlankData.filter((item: any) => {
      const raw = item?.[dimensionName];

      const values = Array.isArray(raw)
        ? raw.map((v) => String(v).trim()).filter(Boolean)
        : [String(raw).trim()];

      return values.some((v) => !options.includes(v));
    });
  };

  useEffect(() => {
    const fallbackData =
      chartProperties.properties[propKey].Geo.unMatchedChartData?.length > 0
        ? chartProperties.properties[propKey].Geo.unMatchedChartData
        : misMatchList;

    setUnMatchedArray(getFilteredUnmatched(fallbackData, options, dimensionName));
  }, [misMatchList, chartProperties.properties[propKey].Geo.unMatchedChartData, options]);

  useEffect(() => {
    (async () => {
      if (!geoJSON || !Array.isArray(geoJSON.features)) {
        console.error('GeoJSON is invalid or empty', geoJSON);
        setOptions([]);
        return;
      }

      const geoMapKey = chartProperties.properties[propKey].Geo.geoMapKey;

      const values: string[] = geoJSON.features
        .map((feature: any) => {
          const props = feature.properties;

          return props[geoMapKey] ?? props.names ?? null;
        })
        .filter((val: any) => val && typeof val === 'string');

      // Remove duplicates and sort
      setOptions(Array.from(new Set(values)).sort());
    })();
  }, [
    chartProperties.properties[propKey].Geo.geoLocation,
    geoJSON,
    chartProperties.properties[propKey].Geo.geoMapKey,
  ]);

  useEffect(() => {
    let isMounted = true;

    async function loadCities() {
      const geo = chartProperties.properties[propKey].Geo;
      const city = geo.geoLocation;

      if (!city) return;

      setLoadingCities(true);

      const dbKey = city.toLowerCase().trim();

      try {
        const cached = await getGeoJSONDB(dbKey);
        if (cached && isMounted) {
          const cityNames =
            cached.data?.cities?.features?.map((f: any) => f.properties?.[geoMapKey]) ||
            cached.data?.features?.map((f: any) => f.properties?.[geoMapKey]) ||
            [];

          setCities(cityNames);
          return;
        }

        const geoData = await getGeoJSON(dbKey, () => {});

        if (!isMounted || !geoData) return;

        let cityNames: string[] = [];

        if (city === 'World') {
          cityNames = geoData.features.map((f: any) => f.properties?.[geoMapKey]);
        } else if (city === 'World Cities' || city.toLowerCase().includes('cities')) {
          cityNames = geoData.cities?.features?.map((f: any) => f.properties?.[geoMapKey]) || [];
        } else {
          cityNames = geoData.features.map((f: any) => f.properties?.[geoMapKey]);
        }

        const uniqueCityNames = Array.from(
          new Set(cityNames.filter(Boolean).map((v: any) => v.trim())),
        );

        setCities(uniqueCityNames);
      } finally {
        if (isMounted) setLoadingCities(false);
      }
    }

    loadCities();

    return () => {
      isMounted = false;
    };
  }, [chartProperties.properties[propKey].Geo.geoLocation, geoMapKey]);

  const handleLocationOnChange = (newValue: string | null, name: string) => {
    const updatedList = [...unMatchedArray];
    const matchIndex = updatedList.findIndex((item: any) => item[dimensionName] === name);

    if (matchIndex !== -1) {
      updatedList[matchIndex] = {
        ...updatedList[matchIndex],
        //selectedKey: newValue,
        selectedKey: newValue || '',
      };
      setUnMatchedArray(updatedList);
    }
  };

  const handleGeoMapUnMatchedReset = () => {
    // grab the original array
    const data = chartProperties.properties[propKey].Geo.unMatchedChartData || [];

    // make a new array with selectedKey cleared
    const resetArray = data.map((item: any) => ({
      ...item,
      selectedKey: '', // overwrite with empty string
    }));
    // dispatch once with the whole new array
    dispatch(changeGeoMapUnMatched(propKey, resetArray));
  };

  //Save updated list
  const handleOkButtonClick = () => {
    changeGeoMapUnMatched(propKey, unMatchedArray);
    handleClose();
  };

  const dispatch = useDispatch();

  // Cancel and reset changes
  const handleCloseButtonClick = () => {
    const fallbackData =
      chartProperties.properties[propKey].Geo.unMatchedChartData?.length > 0
        ? chartProperties.properties[propKey].Geo.unMatchedChartData
        : misMatchList;

    setUnMatchedArray(getFilteredUnmatched(fallbackData, options, dimensionName));
    handleClose();
  };

  // Render unmatched rows
  const UnMatchedListComponent = () => {
    return unMatchedArray.map((item: any, index: number) => {
      useEffect(() => {}, [item.selectedKey]);
      const defaultVal = unMatchedArray.find(
        (selectedItem: any) => selectedItem[dimensionName] === item[dimensionName],
      )?.selectedKey;
      return (
        <div
          key={index}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            columnGap: '0.5rem',
            marginTop: '15px',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              width: '10rem',
              wordWrap: 'normal',
              verticalAlign: 'center',
              fontSize: fontSize.semiLarge,
            }}
          >
            {item[dimensionName]}
          </span>

          <Autocomplete
            defaultValue={''}
            disabled={loadingCities} // BLOCK until world finishes loading
            loading={loadingCities}
            value={item.selectedKey || ''}
            disablePortal
            id="combo-box-demo"
            //onChange={(e: any) => handleLocationOnChange(e, item[dimensionName])}
            onChange={(event, newValue) => handleLocationOnChange(newValue, item[dimensionName])}
            // options={
            //   chartProperties.properties[propKey].Geo.geoLocation === 'Indian Cities'
            //     ? cities
            //     : options
            // }
            // options={cities}
            options={cities.sort()}
            getOptionLabel={(option) => option}
            sx={{
              width: '15rem',
              '& .MuiAutocomplete-inputRoot': {
                maxHeight: '32px !important',
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // label={item.selectedKey?'':"Location"}
                placeholder="Location"
                variant="outlined"
                InputLabelProps={{ shrink: false }}
              />
            )}
          />
        </div>
      );
    });
  };
  if (unMatchedArray.length === 0 && !isNull) {
    return null; // Don't render ONLY if list is empty AND no nulls exist
  }
  return (
    <Dialog
      id="basic-menu"
      className="geoHelpTable"
      open={open}
      PaperProps={{
        sx: {
          minHeight: '20%',
          maxHeight: '75%',
          minWidth: '400px',
        },
      }}
    >
      <DialogTitle sx={{ ...ffDialogTitle, background: '#424242', alignItems: 'center' }}>
        <div>
          {/* <b>Fix Unmatched Locations</b>*/}
          <b style={{ color: 'white', marginRight: '8px' }}>Fix Unmatched Locations</b>
          <Tooltip
            title="Clear Location Fixes"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <svg
              style={{ transform: 'translateY(2px)' }}
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              color="white"
              className="lucide lucide-eraser-icon lucide-eraser"
              onClick={handleGeoMapUnMatchedReset}
            >
              <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21" />
              <path d="m5.082 11.09 8.828 8.828" />
            </svg>
          </Tooltip>
        </div>
        <CloseOutlined
          onClick={handleCloseButtonClick}
          style={{ float: 'right', color: 'white', alignSelf: 'center' }}
        />
      </DialogTitle>
      <DialogContent sx={{ height: '25rem', overflowY: 'auto' }}>
        <>
          {unMatchedArray.length > 0 ? (
            <UnMatchedListComponent />
          ) : (
            <div style={{ padding: '20px', textAlign: 'center', color: 'grey' }}>
              All location names are matched.
            </div>
          )}
        </>
      </DialogContent>
      <div style={{ paddingTop: '20px', textAlign: 'center' }}>
        <Typography>
          {isNull && (
            <div>
              ⚠️ There is a (Blank) data point with value <br /> which can't be matched with any
              location
            </div>
          )}
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '16px',
          columnGap: '1rem',
          paddingRight: '1.5rem',
          paddingBottom: '1rem',
          paddingTop: '1rem',
        }}
      >
        <Button
          onClick={handleCloseButtonClick}
          sx={{
            ...ffButtonStyle,
            border: '2px solid grey',
            color: 'grey',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleOkButtonClick}
          sx={{
            ...ffButtonStyle,
            backgroundColor: '#2bb9bb',
            border: '2px solid #2bb9bb',
            color: 'white',
            '&:hover': {
              backgroundColor: '#ffffff',
              color: '#2bb9bb !important',
              border: '2px solid #2bb9bb',
            },
          }}
        >
          Save
        </Button>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state: any) => ({
  chartControls: state.chartControls,
  chartProperties: state.chartProperties,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  changeGeoMapUnMatched: (propKey: string, value: string) =>
    dispatch(changeGeoMapUnMatched(propKey, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GoeMismatch);
